// WP9.2 — publishes a custom event when a shopper adds a product to compare.
// The compare checkbox's own toggle/storage behaviour is compiled into
// assets/empire.js (no separate source file to edit into directly, and no
// build pipeline in this export to recompile it — see docs/DECISIONS.md
// WP9.5), so this listens via event delegation instead of hooking that
// bundle. Site-wide (compare checkboxes appear on every product grid and
// PDP), so loaded globally rather than per-section.
(function () {
  'use strict';

  document.addEventListener('change', function (event) {
    var checkbox = event.target.closest ? event.target.closest('[data-compare-checkbox]') : null;
    if (!checkbox || !checkbox.checked) {
      return;
    }

    // In both markup sources (snippets/product-grid-item.liquid and
    // snippets/section.flex-pdp.compare-cta.liquid), the JSON data script
    // renders as the immediately preceding sibling of [data-compare-item-wrapper],
    // not a descendant of it — hence previousElementSibling, not querySelector.
    var wrapper = checkbox.closest('[data-compare-item-wrapper]');
    var dataEl = wrapper && wrapper.previousElementSibling &&
      wrapper.previousElementSibling.matches('[data-product-compare-data]')
      ? wrapper.previousElementSibling
      : null;
    var productTitle = null;
    var productHandle = null;

    if (dataEl) {
      try {
        var data = JSON.parse(dataEl.textContent);
        productTitle = data.title || null;
        productHandle = data.handle || null;
      } catch (e) {
        // malformed/missing compare data — publish without product detail rather than fail silently
      }
    }

    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish('bellavoy:compare_item_added', {
        productTitle: productTitle,
        productHandle: productHandle,
      });
    }
  });
})();
